module.exports = {
  NODE_ENV: '"production"',
  API_LOCATION: '"https://api.billingsimo.com/api/v1"',
  API_CLIENT_ID: '2',
  API_CLIENT_SECRET: '"zotsXCZuVteEACl8cp8FhUV5Z3t1yxAtz6IYhmly"'
};



//////////////////
// WEBPACK FOOTER
// ./config/prod.env.js
// module id = rBKV
// module chunks = 15